module.exports = __webpack_public_path__ + "60ff855c4328239945440d4c56770df1.svg";